{
  "slug": "mental-math",
  "title": "Mental Math Techniques",
  "description": "Use decomposition, compensation, and estimation.",
  "category": "Brain training",
  "sections": [
    {
      "heading": "What to train",
      "paragraphs": [
        "Use decomposition, compensation, and estimation.",
        "Specific practice transfers most strongly to similar tasks; broad-transfer claims need caution."
      ]
    },
    {
      "heading": "Exercises",
      "paragraphs": ["Increase difficulty only when accuracy is stable."],
      "bullets": [
        "Add 9 as +10−1.",
        "Multiply by 5 as half ×10.",
        "Treat 25% as one quarter.",
        "Estimate before calculating."
      ]
    },
    {
      "heading": "Sustainable routine",
      "paragraphs": [
        "Use brief regular sessions, adequate sleep, movement, and recovery.",
        "Track accuracy and difficulty rather than expecting a guaranteed IQ increase."
      ]
    }
  ],
  "related": ["can-iq-change-over-time", "working-memory-explained", "processing-speed-explained"],
  "sources": [],
  "faqs": [],
  "summary": "Use decomposition, compensation, and estimation. Content reviewed 18 July 2026."
}
